var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFirstPage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14.19 14.8",
    fill: "#d1d3d4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.5,7.4A.81.81,0,0,0,5.73,8l6.59,6.59a.84.84,0,0,0,.58.24.82.82,0,0,0,.57-.24l.48-.48a.8.8,0,0,0,.24-.58.78.78,0,0,0-.24-.57L8.42,7.4,14,1.87A.83.83,0,0,0,14,.72L13.46.24a.8.8,0,0,0-1.14,0L5.73,6.82A.82.82,0,0,0,5.5,7.4Z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.63,
    height: 14.8,
    rx: 0.66
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirstPage);
export default __webpack_public_path__ + "static/media/first_page.78ae05d2675fa8f8cbfa2573734cac4b.svg";
export { ForwardRef as ReactComponent };